export type FamilyStatus = 'inactive' | 'active' | 'pending';

export const INACTIVE: FamilyStatus = 'inactive';
export const ACTIVE: FamilyStatus = 'active';
export const PENDING: FamilyStatus = 'pending';
